import authorizationMiddleware from '@/api/middleware/authorization';
import dataExtractMiddleware from '@/api/middleware/dataExtract';
import languageMiddleware from '@/api/middleware/language';
import type { Client as AgentClient } from '@/types/schemas/agent-schema';
import type { Client as ProxyClient } from '@/types/schemas/proxy-schema';
import type { Client as RetailerClient } from '@/types/schemas/retailer-schema';
import { OpenAPIClientAxios } from 'openapi-client-axios';

type ApiClientMap = {
  agentApi: AgentClient;
  proxyApi: ProxyClient;
  retailerApi: RetailerClient;
};

type ApiClientType = ApiClientMap[keyof ApiClientMap];

export let api!: ApiClientMap;

const configureMiddleware = (client: ApiClientType) => {
  client.interceptors.response.use(
    dataExtractMiddleware
    // createTokenRefreshMiddleware(client)
  );
  client.interceptors.request.use(authorizationMiddleware);
  client.interceptors.request.use(languageMiddleware);
};

export const initClients = async (): Promise<void> => {
  const agentApiDefinition = new OpenAPIClientAxios({
    definition: `/swagger/agent-swagger.json`,
    withServer: {
      url: `${import.meta.env.VITE_APP_PROXY_TARGET}/agent`,
    },
  });
  const agentApi = await agentApiDefinition.init<AgentClient>();
  configureMiddleware(agentApi);

  const proxyApiDefinition = new OpenAPIClientAxios({
    definition: `/swagger/proxy-swagger.json`,
    withServer: {
      url: `${import.meta.env.VITE_APP_PROXY_TARGET}`,
    },
  });
  const proxyApi = await proxyApiDefinition.init<ProxyClient>();
  configureMiddleware(proxyApi);

  const retailerApiDefinition = new OpenAPIClientAxios({
    definition: `/swagger/retailer-swagger.json`,
    withServer: {
      url: `${import.meta.env.VITE_APP_PROXY_TARGET}/retailer`,
    },
  });
  const retailerApi = await retailerApiDefinition.init<RetailerClient>();
  configureMiddleware(retailerApi);

  api = {
    agentApi,
    proxyApi,
    retailerApi,
  };
};
